module.exports = __webpack_public_path__ + "static/media/soil_plant.eb561937.png";